import React from 'react'
import omit from 'lodash/omit'
import styles from './styles.css'

export interface SelectableProps {
  value: string
  name?: string
  id?: string
  testId?: string
  classes?: {
    default?: string
    selected?: string
  }
  isSingleSelect?: boolean
  headline?: JSX.Element | string
  body?: JSX.Element | string
  image?: string
  secondaryGlyph?: React.StatelessComponent<React.SVGAttributes<SVGElement>>
  icon?: React.Component | string
  multiple?: boolean
  disabled?: boolean
  checked?: boolean
  className?: string
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => any
  overrideRadius?: boolean
  style?: { [key: string]: string }
}

const Selectable: React.SFC<SelectableProps> = ({
  id,
  name,
  value,
  multiple,
  disabled,
  checked,
  children,
  className,
  handleChange,
  testId,
  ...rest
}) => {
  const type = multiple ? 'checkbox' : 'radio'

  const props = omit(rest, 'overrideRadius')

  return (
    <label htmlFor={id} data-testid={testId} className={className} {...props}>
      <input
        disabled={disabled}
        className={styles.hide}
        id={id}
        name={name}
        type={type}
        value={value}
        checked={checked}
        onChange={handleChange}
      />
      {children}
    </label>
  )
}

export default Selectable
